<!--
 * @Author: your name
 * @Date: 2021-11-05 13:47:38
 * @LastEditTime: 2022-04-22 10:05:04
 * @LastEditors: LAPTOP-JM4BAR46
 * @Description: In User Settings Edit
 * @FilePath: \newBj-admin\src\components\BjInputMobile\index.vue
-->
<template>
  <el-form-item :label="label" :prop="prop" :rules="rules" :size="size">
    <el-input
      v-model="id"
      :placeholder="placeholder || $t('chooseText')"
      :clearable="clearable"
      :disabled="disabled"
      :maxlength="maxlength"
      onkeyup="this.value = this.value.replace(/[^\d]/g,'');"
      @keyup.native="proving($event)"
    />
  </el-form-item>
</template>
<script>
// import { patternMobileSimple } from '@/utils/validate';
export default {
  name: 'BjFormItemMobile',
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    placeholder: {
      type: String,
      default: '',
    },
    maxlength: {
      type: Number,
      default: 11,
    },
    size: {
      type: String,
      default: 'mini',
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    label: {
      type: [String, Number],
      default: '手机号',
    },
    prop: {
      type: [String],
      default: null,
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      id: null,
    };
  },
  computed: {
    rules() {
      return [
        {
          validator: this.validatorMobile,
          required: this.required,
          trigger: 'blur',
        },
      ];
    },
  },
  watch: {
    value: {
      handler(v) {
        this.id = v;
      },
      immediate: true,
    },
    id(v) {
      this.$emit('input', v);
    },
  },
  methods: {
    validatorMobile(rule, value, callback) {
      if (typeof value == 'number') value = String(value);
      if (!value) {
        if (rule.required) {
          callback(new Error(this.$t('PleasePhoneNumberText')));
        } else {
          callback();
        }
      } else {
        callback();
      }
      // else {
      //   if (!patternMobileSimple.test(String(value))) {
      //     callback(new Error(this.$t('MobileFormatErrorText')));
      //   } else {
      //     callback();
      //   }
      // }
    },
    // 限制正整数输入
    proving(e) {
      // 禁止0开头负数和小数点
      // e.target.value = e.target.value.replace(/\D/g, '').replace(/^(?:\+|0)[0-9]+$/g, '');
      // e.target.value = parseInt(e.target.value.replace(/\D/g, ''));
      // if (isNaN(e.target.value)) {
      //   e.target.value = '';
      // }
    },
  },
};
</script>
